export default __webpack_public_path__ + "static/media/118.51bad9e4.jpg";